import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPage, { LegalSection } from '../../components/LegalPage/LegalPage';

const TermsAndConditions: React.FC = () => {
  const { t } = useTranslation();

  const sections = t('termsAndConditions.sections', { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      title={t('termsAndConditions.title')}
      lastUpdated={t('termsAndConditions.lastUpdated')}
      tocLabel={t('legal.tocLabel')}
      backToTopLabel={t('legal.backToTop')}
      sections={sections}
    />
  );
};

export default TermsAndConditions;
